import React from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';
import { NUMBERS } from 'constants/index';

type Props = NumberFormatProps & {
    inputRef: (instance: NumberFormat | null) => void;
    onChange: (value: string | undefined) => void;
    name: string;
};

const ApariNumberFormatAsString: React.FC<Props> = props => {
    const { inputRef, name, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            name={name}
            getInputRef={inputRef}
            thousandSeparator={NUMBERS.default.thousandSeparator}
            decimalSeparator={NUMBERS.default.decimalSeparator}
            onValueChange={values => {
                onChange(values.value);
            }}
            allowNegative={false}
            suffix={' EUR'}
            min={0}
            decimalScale={2}
            fixedDecimalScale
            allowLeadingZeros={false}
            isNumericString
        />
    );
};

export default ApariNumberFormatAsString;
